import { Component, OnDestroy, OnInit } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { Subscription } from 'rxjs';
import { MouldLogOverviewService } from 'src/app/state';

@Component({
  selector: 'em-mould-log-overview-modal',
  templateUrl: './mould-log-overview-modal.component.html',
  standalone: false,
})
export class MouldLogOverviewModalComponent implements OnInit, OnDestroy {
  public loading$ = this.mouldLogOverviewService.loading$;
  public error$ = this.mouldLogOverviewService.error$;
  public mouldLogs$ = this.mouldLogOverviewService.mouldLogEntries$;

  public readonly trackByRef = trackByRef;

  private readonly subscriptions = new Subscription();

  public constructor(private readonly mouldLogOverviewService: MouldLogOverviewService) {}

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit() {
    this.subscriptions.add(
      this.mouldLogOverviewService.loadMouldLogByEquipmentNumber().subscribe()
    );
  }
}
